import { Flex, Typography } from "antd";
import { PlateItemHeader } from "components/PlateList/PlateItemHeader";
import { QUOTE_SELECTION_ENUM, QUOTE_STATUS_ENUM, QUOTE_STATUSES, QuoteEntity, RISK_STATUS_ENUM } from "interfaces";
import { observer } from "mobx-react-lite";
import { Status } from "ui";
import { dateFormat, isStatusIncluded } from "utils";
import { QuoteActionBtn } from "../QuoteActionBtn";
import { ReactComponent as CompanyIcon } from "images/citites.svg";
import { QUOTE_SELECTION, DIRECT_PAYMENT_CUSTOMER_LP } from "utils/envConstants";
import { useStores } from "stores";
import { Link, Route } from "react-router-dom";
import { routes } from "constants/routes";

export const QuoteHeader = observer(({ quote }: { quote: QuoteEntity }) => {
  const { user } = useStores();
  const { isProvider, isCustomer } = user.roles;

  const showLpName =
    isProvider || (isCustomer && QUOTE_SELECTION === QUOTE_SELECTION_ENUM.CUSTOMER && !DIRECT_PAYMENT_CUSTOMER_LP);

  return (
    <Flex align="center" gap="large" style={{ width: "100%" }} justify="space-between">
      <Flex gap="large">
        <Typography.Text className="text-description">Создана: {dateFormat(quote.created, true)}</Typography.Text>
        {!showLpName && (
          <Link to={`/${routes.companies}/${quote.lpCompanyId}`} className="hover-underline">
            <Flex align="center" gap={4}>
              <CompanyIcon
                style={{ width: "16px", height: "16px", marginBottom: "2px" }}
                className="text-description"
              />
              <Typography.Text className="text-description">{quote.lpName}</Typography.Text>
            </Flex>
          </Link>
        )}
      </Flex>
      <Flex gap="small">
        <QuoteActionBtn quote={quote as QuoteEntity} />
        <Status color={QUOTE_STATUSES.colors[quote.status]} children={QUOTE_STATUSES.texts[quote.status]} />
      </Flex>
    </Flex>
  );
});
